export class LookupsBooleanChoiceRequest {
    isToGetMedicineGroupTypeLookup: boolean = false;
    isToGetMedicineSubgroupLookup: boolean = false;
    isToGetMedicinePresentationTypeLookup: boolean = false;
    isToGetMedicineAdministrationTypeLookup: boolean = false;
    isToGetKitMultiselectLookup: boolean = false;
    isToGetMeasurementUnitLookup: boolean = false;
    isToGetDoseToAdministered: boolean = false;
    isToGetRelationMedicinePresentationTypeAndMeasurementUnit: boolean = false;
    isToGetRelationMedicinePresentationTypeAndDoseToAdministered: boolean = false;
    isToGetDilution: boolean = false;
    isToGetFrequency: boolean = false;
    isToGetSubFrequency: boolean = false;
    isToGetDoAdministered: boolean = false;
    isToGetDilutionUnit: boolean = false;
    isToGetTreatmentPeriod: boolean = false;
    isToGetUsage: boolean = false;
}